import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useState} from "react";
import {formatCurrency, formatDate, handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import dayjs from "dayjs";
import {DesktopDatePicker} from "@mui/x-date-pickers";

export default function ClientMergeInvoices({invoices, invoiceGroups, show, handleSave, handleClose}) {

  const [context, setContext] = useContext(AppContext);
  const [saving, setSaving] = useState(false);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues({})
  });



  const saveInvoiceFn = (data) => {
    setSaving(true);
    handleSave({
      dueDate: dueDate
    });
  }

  const [dueDate, setDueDate] = useState(dayjs(new Date()));

  const newTotal = () => {
    let d = 0.00;
    invoices.map((inv)=> {
      d += parseFloat(inv.amountDue);
    });
    invoiceGroups.map((inv)=> {
      d += parseFloat(inv.amountDue);
    });
    return d;
  }


  return (
    <Modal onHide={handleClose} size={'md'} show={show}>
      <form
        onSubmit={handleSubmit(saveInvoiceFn)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>Merge Invoices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>

                <table className={'table'}>
                  <thead>
                  <tr>
                    <th>Name</th>
                    <th className={'text-right'}>Due</th>
                    <th className={'text-right'}>Amount</th>
                  </tr>
                  </thead>
                  <tbody>

                  {invoices?.map((invoice, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{invoice?.invoiceGroup ? invoice?.referenceId : invoice.inventoryItem?.name}</td>
                        <td className={'text-right'}>{formatDate(invoice.dueDate)}</td>
                        <td className={'text-right'}>{formatCurrency(invoice.amountDue)}</td>
                      </tr>
                    )
                  })}

                  {invoiceGroups?.map((invoice, idx) => {
                    return (
                      <tr key={idx}>
                        <td>{invoice.referenceId}</td>
                        <td className={'text-right'}>{formatDate(invoice.dueDate)}</td>
                        <td className={'text-right'}>{formatCurrency(invoice.amountDue)}</td>
                      </tr>
                    )
                  })}
                  </tbody>
                  <tfoot>
                  <tr>
                    <td colSpan={2} className={'text-right'}>
                      <b>Total:</b>
                    </td>
                    <td className={'text-right'}>
                      {formatCurrency(newTotal(invoices))}
                    </td>
                  </tr>
                  </tfoot>
                </table>
                <Row className={'mt-2'}>

                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">
                      <label htmlFor="billingEndDate">Due Date</label>
                      <div>
                        <DesktopDatePicker
                          {...register('dueDate')}
                          slotProps={{
                            actionBar: {
                              actions: ['today'],
                            },
                          }}
                          onChange={(e) => {
                            if (e?.$d) {
                              setValue('dueDate', new Date(e.$d));
                            } else {
                              setValue('dueDate', null);
                            }
                          }}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}